import { render } from "./ProceedBtn.vue?vue&type=template&id=3eb5d59a&ts=true"
import script from "./ProceedBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProceedBtn.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ProceedBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3eb5d59a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3eb5d59a', __exports__)) {
    api.reload('3eb5d59a', __exports__)
  }
  
  module.hot.accept("./ProceedBtn.vue?vue&type=template&id=3eb5d59a&ts=true", () => {
    api.rerender('3eb5d59a', render)
  })

}


export default __exports__